/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIncreaseV1AchEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_INCREASE_V1_ACH_EVENT_ENTITY_NAME = 'exc.increase.v1.AchEvent';
export const excIncreaseV1AchEventEntity = new schema.Entity<ExcIncreaseV1AchEvent>(EXC_INCREASE_V1_ACH_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcIncreaseV1AchEvent) => `${entity.metadata?.eventId}` });

